import React from "react";
import {
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  Box
} from "@mui/material";

const Assignments = ({ user }) => (
  <Container maxWidth="md" sx={{ mt: 5 }}>
    <Typography variant="h4" gutterBottom>
      Your Assignments
    </Typography>

    <Paper elevation={3} sx={{ p: 3 }}>
      <List>
        {user.current_assignments.length === 0 ? (
          <Typography variant="body1">You have no current assignments.</Typography>
        ) : (
          user.current_assignments.map((a, index) => (
            <Box key={index}>
              <ListItem
                alignItems="flex-start"
                sx={{
                  borderRadius: 1,
                  transition: "background-color 0.2s ease, transform 0.1s ease",
                  "&:hover": {
                    backgroundColor: "#f0f0f0",
                    cursor: "pointer",
                    transform: "translateY(-1px)",
                  },
                }}
                onClick={() => {
                  // Example: trigger a navigation or detailed view
                  console.log("Clicked assignment:", a.test_name);
                }}
              >
                <ListItemText
                  primary={
                    <Typography variant="h6" component="span">
                      {a.test_name}
                    </Typography>
                  }
                  secondary={
                    <>
                      <Typography component="span" variant="body2" color="text.primary">
                        Assigned by {a.assigned_by} on {a.assigned_on}
                      </Typography>
                      <br />
                      <Typography component="span" variant="body2" color="text.secondary">
                        Due {a.due_date}
                      </Typography>
                    </>
                  }
                />
              </ListItem>
              {index < user.current_assignments.length - 1 && <Divider />}
            </Box>
          ))
        )}
      </List>
    </Paper>
  </Container>
);

export default Assignments;
